<template>
  <div>
    <a :href="articleUrl(article)" v-bind="bind(article)" class="ig-widget-container flex items-center" @click="sliderClickDataLayer()">
      <OImage loading="lazy" :src="getImageUrl(article.image)" class="ig-widget-image object-cover ml-3.75 mr-2" :alt="article.title" />
      <h3 class="ig-widget-title text-sm leading-18 font-bold line-clamp-4">
        {{ article.title }}
      </h3>
    </a>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    OImage,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup({ article, index }) {
    const articleUrl = (article) => {
      return getArticleUrl({ article });
    };
    const bind = (article) => {
      const params = {};
      if (article?.redirectUrl) {
        params.rel = 'nofollow';
      }
      return params;
    };
    // Data Layer Impression & Click
    const { sendDataLayer } = useTracking();
    const { clickEvent: sliderClickDataLayer } = sendDataLayer(
      {
        item: article,
        list: 'Haber Detay - Instagram Köprü - Sticky',
        position: index + 1,
      },
      ['click']
    );
    return { getImageUrl, articleUrl, bind, sliderClickDataLayer };
  },
});
</script>

<style lang="scss" scoped>
.ig-widget-container {
  height: 96px;
}
.ig-widget-image {
  width: 131px;
  height: 76px;
}
.ig-widget-title {
  width: 155px;
}
@media (max-width: 374px) {
  .ig-widget-container {
    height: 90px;
  }
  .ig-widget-image {
    width: 100px;
    height: 58px;
    margin: 0 8px;
  }
  .ig-widget-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
